export const paymentMethodSplitSchema = [
  { name: "Payment_Method", label: "Payment Category", sort: false },
  { name: "value", label: "Value" },
  { name: "percentage1", label: "%" },
  { name: "count", label: "Count" },
  { name: "percentage2", label: "%" },
];
